import { userAttributesClient } from '../../client/userAttributesClient';
export const USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS = 'Tasks:Leads:FollowUpTasks:hide';
export const fetchLeadFollowUpHiddenSettings = (__unusedKey, httpClient) => {
  return userAttributesClient.withHttpClient(httpClient).fetch(USER_ATTRIBUTE_HIDE_LEAD_FOLLOW_UP_TASKS, 'false').then(value => {
    return value === 'true';
  });
};